export default __webpack_public_path__ + "static/Plots0085-bc94778ca94b989a0116e448c1dc0b30.jpg";